// Models
import SettlementData from '../models/settlementData';

import {
    FETCH_SETTLEMENT_SUCCESS,
    FETCH_SETTLEMENT_ERROR,
    HIDE_SETTLEMENT_LOADER,
    SHOW_SETTLEMENT_LOADER,
    FETCH_SETTLEMENT_METRICS_SUCCESS,
    FETCH_SETTLEMENT_METRICS_ERROR,
    FETCH_AVAILABLE_BALANCE_SUCCESS,
    FETCH_AVAILABLE_BALANCE_ERROR,
    FETCH_ODS_FEE_DETAILS_SUCCESS,
    FETCH_ODS_FEE_DETAILS_ERROR,
    PROCESS_ODS_SUCCESS,
    PROCESS_ODS_ERROR,
    REMOVE_AVAILABLE_BALANCE_LOADING,
    SET_AVAILABLE_BALANCE_LOADING,
    SET_ODS_PAGE_LOADING,
    REMOVE_ODS_PAGE_LOADING,
    SET_PROCESS_LOADING,
    REMOVE_PROCESS_LOADING,
    FETCH_NET_SETTLEMENT_SUCCESS,
    FETCH_NET_SETTLEMENT_ERROR,
} from './settlement.constants';

const initialState = {
    tableData: [],
    pagination: {},
    error: null,
    isLoading: false,
    settlementMetric: {},
    availableBalance: {},
    availableBalanceLoading: false,
    availableBalanceError: null,
    odsFeeDetails: {},
    odsPageLoader: false,
    processLoader: false,
    netSettlementAmount: {},
};

export const settlementReducer = (state = initialState, action) => {
    switch (action.type) {
        case FETCH_SETTLEMENT_SUCCESS: {
            const settlementData = new SettlementData(action.payload);
            return {
                ...state,
                ...settlementData,
                error: null,
            };
        }
        case FETCH_SETTLEMENT_ERROR:
            return {
                ...state,
                ...action.payload,
            };
        case FETCH_SETTLEMENT_METRICS_SUCCESS: {
            const settlementMetricsData = new SettlementData(action.payload);
            return {
                ...state,
                ...settlementMetricsData,
                error: null,
            };
        }
        case FETCH_SETTLEMENT_METRICS_ERROR:
            return {
                ...state,
                ...action.payload,
            };

        case FETCH_AVAILABLE_BALANCE_SUCCESS:
            return {
                ...state,
                availableBalance: action.payload,
                availableBalanceError: null,
            };
        case FETCH_AVAILABLE_BALANCE_ERROR:
            return {
                ...state,
                availableBalanceError: action.payload.error,
                availableBalance: {},
            };
        case FETCH_NET_SETTLEMENT_SUCCESS:
            return {
                ...state,
                netSettlementAmount: action.payload,
                netSettlementAmountError: null,
            };
        case FETCH_NET_SETTLEMENT_ERROR:
            return {
                ...state,
                netSettlementAmountError: action.payload.error,
                netSettlementAmount: {},
            };
        case FETCH_ODS_FEE_DETAILS_SUCCESS:
            return {
                ...state,
                odsFeeDetails: action.payload,
                error: null,
            };
        case FETCH_ODS_FEE_DETAILS_ERROR:
            return {
                ...state,
                odsFeeDetails: null,
            };
        case PROCESS_ODS_SUCCESS:
            return {
                ...state,
                settledAmount: action.payload,
                error: null,
            };
        case PROCESS_ODS_ERROR:
            return {
                ...state,
                settledAmount: null,
                error: action.error,
            };

        case SHOW_SETTLEMENT_LOADER:
            return { ...state, isLoading: true };
        case HIDE_SETTLEMENT_LOADER:
            return { ...state, isLoading: false };
        case SET_AVAILABLE_BALANCE_LOADING:
            return { ...state, availableBalanceLoading: true };
        case REMOVE_AVAILABLE_BALANCE_LOADING:
            return { ...state, availableBalanceLoading: false };
        case SET_ODS_PAGE_LOADING:
            return { ...state, odsPageLoader: true };
        case REMOVE_ODS_PAGE_LOADING:
            return { ...state, odsPageLoader: false };
        case SET_PROCESS_LOADING:
            return { ...state, processLoader: true };
        case REMOVE_PROCESS_LOADING:
            return { ...state, processLoader: false };
        default:
            return state;
    }
};
